import { produce } from 'immer';
import { extractError } from 'app/lib/error';
import { CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_SNOWFLAKE_TABLE_ALREADY_EXISTS } from 'app/store/__generated__/events/upload';
import {
    CLOSE_DETAILS_DIALOG,
    CLOSE_DIALOG,
    CLOSE_OVERWRITE_DIALOG,
    COMPLETE_DATA_UPLOAD,
    INITIATE_DATA_UPLOAD,
    OPEN_DIALOG,
    SET_FILE
} from './types.js';

export const INITIAL_STATE = {
    uploadProgress: null,
    errors: null,
    file: null,
    isOpen: false,
    isUploading: false,
    isUploadAborted: false,
    isExistingTable: false
};

export const fileUpload = produce((draft, action) => {
    switch (action.type) {
        case OPEN_DIALOG:
            draft.isOpen = true;
            break;
        case CLOSE_DIALOG:
            draft.isOpen = false;
            draft.isUploading = false;
            draft.errors = null;
            draft.file = null;
            break;
        case CLOSE_DETAILS_DIALOG:
            draft.isUploading = false;
            draft.errors = null;
            draft.file = null;
            break;
        case CLOSE_OVERWRITE_DIALOG:
            draft.isExistingTable = false;
            break;
        case SET_FILE:
            draft.file = action.payload.file;
            break;
        case INITIATE_DATA_UPLOAD.STARTED:
        case COMPLETE_DATA_UPLOAD.STARTED: {
            draft.uploadProgress = 0;
            draft.errors = null;
            draft.isUploading = true;
            draft.isUploadAborted = false;
            draft.isExistingTable = false;
            break;
        }
        case INITIATE_DATA_UPLOAD.FAILED:
        case COMPLETE_DATA_UPLOAD.FAILED:
            draft.errors = [extractError(action.payload)];
            draft.isUploading = false;
            break;
        case COMPLETE_DATA_UPLOAD.PROGRESS:
            draft.uploadProgress = action.payload;
            break;

        case COMPLETE_DATA_UPLOAD.COMMAND_CHAIN_COMPLETED: {
            const failures = action.payload?.failures || [];
            if (failures.length) {
                const isExistingTableFailure = failures.some(
                    (failure) =>
                        failure._type ===
                        CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_SNOWFLAKE_TABLE_ALREADY_EXISTS
                );
                if (isExistingTableFailure) {
                    draft.isExistingTable = true;
                } else {
                    draft.errors = failures;
                }
                draft.isUploading = false;
            } else {
                draft.isOpen = false;
                draft.isUploading = false;
                draft.file = null;
            }
            break;
        }

        case COMPLETE_DATA_UPLOAD.ABORTED:
            draft.isUploadAborted = true;
            break;

        case COMPLETE_DATA_UPLOAD.ENDED:
            draft.uploadProgress = 1;
            break;

        default:
            break;
    }
}, INITIAL_STATE);
